<template>
  <div class="nav-contaniner">
    <div class="nav-left">
      <!-- 公司集团切换 -->
      <brand-center />
    </div>
    <div class="nav-right">
      <slot name="navbar"></slot>
      <!-- 我的待办 -->
      <todo-nav v-if="judgePermission('getAffairsCount') || judgePermission('workbench_get_deal_with_list_button')" />
      <!-- 个人中心 -->
      <personal-center />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import personalCenter from './personalCenter.vue'
import todoNav from './todoNav.vue'
import brandCenter from './brandCenter.vue'

export default {
  name: 'Navbar',
  components: {
    personalCenter,
    todoNav,
    brandCenter,
  },
  data() {
    return {

    }
  },
  props: {
    // 子应用控制帮助中心是否展示
    // eslint-disable-next-line vue/no-unused-properties
    showHelpCenterBySub: {
      type: Boolean,
      default: false,
    },
    // welcome页不展示
    // eslint-disable-next-line vue/no-unused-properties
    isHelp: {
      type: Boolean,
      default: false,
    },
    helpNavClick: {
      type: Function,
      default: () => { },
    },
    // eslint-disable-next-line vue/no-unused-properties
    httpMethods: {
      type: Function,
      default: () => { },
    },
    // eslint-disable-next-line vue/no-unused-properties
    request: {
      type: Function,
      default: () => { },
    },
    // eslint-disable-next-line vue/no-unused-properties
    authUtils: {
      type: Object,
      default: () => { },
    },
  },
  computed: {
    ...mapGetters(['sidebar', 'userInfo', 'pathnames']),
  },
  provide() {
    return {
      openHelpCenterFun: this.helpNavClick,
    }
  },
}
</script>
<style lang="scss">
$--border-radius-large: 8px;

.nav-contaniner {
  position: absolute;
  width: calc(100% - 80px);
  top: 0;
  left: 80px;
  border-top-left-radius: $--border-radius-large !important;
  display: flex;
  justify-content: space-between;
  height: 48px;
  background-color: #fff;
  font-size: 14px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 0 32px;

  .nav-bar-item {
    cursor: pointer;
    color: rgba(0, 0, 0, 0.85);
    padding: 6px 8px;
    border-radius: 5px;

    .icon {
      margin-right: 2px;
    }
  }

  .nav-bar-item:hover {
    color: #276BEC;
    background: #EEF2FE;
  }


  .nav-left {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .nav-right {
    display: flex;
    align-items: center;
  }
}
</style>
